import { render, staticRenderFns } from "./DialogReemitirDae.vue?vue&type=template&id=45fe7b0c"
import script from "./DialogReemitirDae.vue?vue&type=script&lang=js"
export * from "./DialogReemitirDae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports